<template>
  <g>
    <defs>
      <path
        id="envelope@1x-a"
        d="M17.6,6 L6.4,6 C5.0745166,6 4,7.09130592 4,8.4375 L4,16.5625 C4,17.9086941 5.0745166,19 6.4,19 L17.6,19 C18.9254834,19 20,17.9086941 20,16.5625 L20,8.4375 C20,7.09130592 18.9254834,6 17.6,6 Z M6.4,7.625 L17.6,7.625 C18.0418278,7.625 18.4,7.98876864 18.4,8.4375 L12,12.4025 L5.6,8.4375 C5.6,7.98876864 5.9581722,7.625 6.4,7.625 Z M18.4,16.5625 C18.4,17.0112314 18.0418278,17.375 17.6,17.375 L6.4,17.375 C5.9581722,17.375 5.6,17.0112314 5.6,16.5625 L5.6,10.29 L11.584,14.003125 C11.8315209,14.1482641 12.1364791,14.1482641 12.384,14.003125 L18.4,10.29 L18.4,16.5625 Z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <rect
        width="24"
        height="24"
        fill="#E3E3E3"
        fill-opacity=".01"
        style="mix-blend-mode:color-burn"
      />
      <use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#envelope@1x-a" />
    </g>
  </g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>